import settings from '@/settings'

let get = (headers) => {
  return fetch(`${settings.apetrusApi}/versionamento/posto/`, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

let ler = (headers) => {
  return fetch(`${settings.apetrusApi}/versionamento/lerposto/`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers
  })
}

export default {
  get,
  ler
}
